"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "_01-work_time",
  "data-name": "01-work time",
  transform: "translate(-4 -4)"
}, /*#__PURE__*/_react.default.createElement("g", {
  id: "linear_color",
  "data-name": "linear color",
  transform: "translate(4 4)"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2132",
  "data-name": "Trac\xE9 2132",
  d: "M151.375,135.6a1.8,1.8,0,1,0,0-3.6H117.8a1.8,1.8,0,1,0,0,3.6Z",
  transform: "translate(-99.212 -112.814)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2133",
  "data-name": "Trac\xE9 2133",
  d: "M74.75,51.868V18.39a3.6,3.6,0,0,0-3.6-3.6H50.767V7.6a3.6,3.6,0,0,0-3.6-3.6H31.58a3.6,3.6,0,0,0-3.6,3.6v7.195H7.6A3.6,3.6,0,0,0,4,18.39V61.559a3.6,3.6,0,0,0,3.6,3.6H47.27A16.188,16.188,0,1,0,74.75,51.868ZM31.58,7.6H47.169v7.195H31.58ZM7.6,18.39H71.152V39.974H44.771v-1.8a1.8,1.8,0,0,0-1.8-1.8H35.777a1.8,1.8,0,0,0-1.8,1.8v1.8H7.6ZM37.576,39.974h3.6v5.85l-1.8,1.8-1.8-1.8ZM7.6,43.572H33.979v3a1.8,1.8,0,0,0,.527,1.272l3.6,3.6a1.8,1.8,0,0,0,2.544,0l3.6-3.6a1.8,1.8,0,0,0,.527-1.272v-3H71.152v5.6A16.182,16.182,0,0,0,47.27,61.559H7.6ZM65.157,75.818V74.15a1.8,1.8,0,1,0-3.6,0v1.668A12.617,12.617,0,0,1,50.9,65.157h1.668a1.8,1.8,0,1,0,0-3.6H50.9A12.617,12.617,0,0,1,61.559,50.9v1.668a1.8,1.8,0,0,0,3.6,0V50.9A12.617,12.617,0,0,1,75.818,61.559H74.15a1.8,1.8,0,1,0,0,3.6h1.668A12.617,12.617,0,0,1,65.157,75.818Z",
  transform: "translate(-4 -4)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2134",
  "data-name": "Trac\xE9 2134",
  d: "M366.118,356.528l-3.88,3.88-3.637-1.819a1.8,1.8,0,0,0-1.609,3.218l4.8,2.4a1.8,1.8,0,0,0,2.076-.337l4.8-4.8a1.8,1.8,0,1,0-2.544-2.544Z",
  transform: "translate(-303.235 -303.238)",
  fill: "#fff"
})));
let viewBox = '0 0 75.548 75.561';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'PreparationEmploiIcon', viewBox);
